import type { IconNode } from '../types';

/**
 * @name cheese
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjEgMTl2LTdjLTEtNi03LTktNy05bC0yLjEgMS41YTIgMiAwIDAgMS0zIDIuMkwzIDExdjljMCAuNi40IDEgMSAxaDNhMiAyIDAgMCAxIDQgMGg4IiAvPgogIDxwYXRoIGQ9Ik05IDEySDMiIC8+CiAgPHBhdGggZD0iTTkgMTJjMC0uOCAxLjMtMS41IDMtMS41czMgLjcgMyAxLjVhMyAzIDAgMSAxLTYgMCIgLz4KICA8cGF0aCBkPSJNMjEgMTJoLTYiIC8+CiAgPGNpcmNsZSBjeD0iMTkiIGN5PSIxOSIgcj0iMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/cheese
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const cheese: IconNode = [
  [
    'path',
    {
      d: 'M21 19v-7c-1-6-7-9-7-9l-2.1 1.5a2 2 0 0 1-3 2.2L3 11v9c0 .6.4 1 1 1h3a2 2 0 0 1 4 0h8',
      key: '1eyc4g',
    },
  ],
  ['path', { d: 'M9 12H3', key: '1fo4ml' }],
  ['path', { d: 'M9 12c0-.8 1.3-1.5 3-1.5s3 .7 3 1.5a3 3 0 1 1-6 0', key: '11t6s9' }],
  ['path', { d: 'M21 12h-6', key: 'bt1uis' }],
  ['circle', { cx: '19', cy: '19', r: '2', key: '17f5cg' }],
];

export default cheese;
